// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.0001 3H1L1.00112 20L7.96474 20L12.0004 15.9644L16.036 20L23.0001 20L23.0001 3ZM16.9505 11.3828C14.2168 8.6491 9.78468 8.6491 7.05101 11.3828L6.3439 12.0899L4.92969 10.6757L5.63679 9.96856C9.15151 6.45384 14.85 6.45384 18.3647 9.96856L19.0718 10.6757L17.6576 12.0899L16.9505 11.3828ZM14.1218 14.2109C12.9502 13.0393 11.0507 13.0393 9.87913 14.2109L9.17203 14.918L7.75781 13.5038L8.46492 12.7967C10.4175 10.8441 13.5834 10.8441 15.536 12.7967L16.2431 13.5038L14.8289 14.918L14.1218 14.2109Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.9144 21.9999L12.0002 18.0857L8.08594 21.9999L15.9144 21.9999Z"}}]};

const AirplayWaveFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'airplay-wave-filled',
    ref,
    icon: element,
  },
));

AirplayWaveFilledIcon.displayName = 'AirplayWaveFilledIcon';

export default AirplayWaveFilledIcon;
